
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorPiston75 as ObiTwowayAcuatorPiston75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-piston-75.js';
 
 
 

 
 export const ObiTwowayAcuatorPiston75 = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-piston-75',
   elementClass: ObiTwowayAcuatorPiston75Element,
   events: {
     
   }
  });
 
 